import { InputType } from "../models/common.models";
import Handyman from "@mui/icons-material/Handyman";
import AccountTree from "@mui/icons-material/AccountTree";
import SupportAgent from "@mui/icons-material/SupportAgent";
import QueryStats from "@mui/icons-material/QueryStats";
import { LoginPageIntroCards } from "./texts";

export interface LoginField {
  name: string;
  placeholder?: string;
  label: string;
  type: InputType;
  inputType: LoginInputTypes;
}

export interface LoginIntroCard {
  icon: any;
  title: string;
  text: string;
}

export enum LoginCredentials {
  EMAIL = "email",
  PASSWORD = "password",
}

export enum LoginInputTypes {
  EMAIL = "email",
  PASSWORD = "current-password",
}

export const loginIntroCards: LoginIntroCard[] = [
  {
    icon: Handyman,
    title: LoginPageIntroCards.TOOL_SET,
    text: LoginPageIntroCards.TOOL_SET_DESCRIPTION,
  },
  {
    icon: AccountTree,
    title: LoginPageIntroCards.ORDERING_PROCESS,
    text: LoginPageIntroCards.ORDERING_PROCESS_DESCRIPTION,
  },
  {
    icon: QueryStats,
    title: LoginPageIntroCards.ORDER_TRACKING,
    text: LoginPageIntroCards.ORDER_TRACKING_DESCRIPTION,
  },
  {
    icon: SupportAgent,
    title: LoginPageIntroCards.ROUND_THE_CLOCK,
    text: LoginPageIntroCards.ROUND_THE_CLOCK_DESCRIPTION,
  },
];
